/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterConversationUserActionKind =
  (typeof FilterConversationUserActionKind)[keyof typeof FilterConversationUserActionKind];

export const FilterConversationUserActionKind = {
  conversation_user_action: 'conversation_user_action',
} as const;
